module.exports = __webpack_public_path__ + "static/media/25b.6b984fa0.jpg";